import { useSpaceEnabledContentTypes } from '@confluence/create-blank-fabric-page/entry-points/useSpaceEnabledContentTypes';
import { useSpaceKey } from '@confluence/space-utils/entry-points/useSpaceKey';

const DATABASE_COMPETITORS = [
	{ name: 'Google Sheets', domains: [/docs\.google\.com\/spreadsheets/i] },
	{ name: 'Microsoft Lists', domains: [/lists\.live\.com/i] },
	{ name: 'SmartSheet', domains: [/smartsheet\.com/i] },
	{ name: 'Airtable', domains: [/airtable\.com/i] },
	{ name: 'AsanaList', domains: [/app\.asana\.com.*\/list\//i] },
	{ name: 'AsanaBoard', domains: [/app\.asana\.com.*\/board\//i] },
];

export const useIsEligibleDatabaseCompetitor = (url: string) => {
	const spaceKey = useSpaceKey();
	const { isCreateDatabaseEnabled } = useSpaceEnabledContentTypes(spaceKey ?? undefined);

	const databaseCompetitor = DATABASE_COMPETITORS.find((competitor) =>
		competitor.domains.some((regex) => regex.test(url)),
	);

	return {
		databaseCompetitorName: isCreateDatabaseEnabled ? databaseCompetitor?.name : undefined,
	};
};
